import { useTwoFactorAuthenticationFactory } from "@Modules/admin/views/user/store"
import createStore from "@Stores/base-factories"

const { Provider, useStore } = createStore()
  .extendHookCollectionFactory('organization/user')
  .extend(useTwoFactorAuthenticationFactory)
  .factory()

export {
  Provider as ProfileProvider,
  useStore as useProfileStore,
}
